const codeLowerCaseA = 65;
const codeUpperCaseZ = 122;
export const VALID_KEY_EVENTS = ["keydown", "keyup", "keypress"];

export const getAsciiCode = (event) => {
  let keyCode = event.which;
  if (keyCode >= codeLowerCaseA && keyCode <= codeUpperCaseZ) {
    keyCode = event.key.charCodeAt(0);
  }
  return keyCode;
};

export const convertToAsciiEquivalent = (inputArray) =>
  inputArray.map((item) => {
    if (typeof item === "string") {
      return item.charCodeAt(0);
    }
    return item;
  });

const isKeyFromGivenList = (keyCode, allowedKeys = []) => {
  if (
    allowedKeys === null ||
    allowedKeys.includes(keyCode) ||
    allowedKeys.length === 0
  ) {
    return true;
  }
  return false;
};
export const onKeyPress = (event, callback, allowedKeys) => {
  const currentKeyCode = getAsciiCode(event);
  if (isKeyFromGivenList(currentKeyCode, allowedKeys)) {
    callback(event, currentKeyCode);
  }
};
